import styled from 'styled-components'

import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import IconButton from '../IconButton/IconButton'

export const StyledFooter = styled.nav`
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  display: flex;
  padding: ${pxToRem(10)} 0;
  background-color: ${({ theme }) => theme.colors.unique.black};
  @media ${deviceMax.tablet} {
    flex-direction: Row;
    padding: ${pxToRem(15)} 0;
  }
`

export const Separator = styled.div`
  margin: 0 ${pxToRem(15)};
  border-radius: ${pxToRem(1)};
  width: ${pxToRem(1)};
  height: ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  @media ${deviceMax.tablet} {
    margin: ${pxToRem(15)} 0 ${pxToRem(15)} 0;
    width: 100%;
    height: ${pxToRem(1)};
  }
`

export const Subscribe = styled.button`
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  margin: 0 ${pxToRem(15)};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)};
  width: ${({ $isMobile }) =>
    $isMobile ? `calc(100% - ${pxToRem(30)})` : `${pxToRem(480)}`};
  max-height: ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.unique.white};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  text-align: start;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  @media ${deviceMax.tablet} {
    margin: ${pxToRem(5)} ${pxToRem(15)} ${pxToRem(5)} ${pxToRem(15)};
    width: calc(100% - ${pxToRem(30)});
    padding: ${pxToRem(12)} 0 ${pxToRem(12)} ${pxToRem(10)};
  }
`

export const StyledSVG = styled(IconButton)`
  margin: 0 ${pxToRem(15)};
  svg {
    height: fit-content;
  }
`

export const StyledSocials = styled.ul`
  align-items: center;
  display: flex;
`

export const StyleIcon = styled(ArrowRight)`
  margin-right: ${pxToRem(10)};
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  padding: ${pxToRem(4)} ${pxToRem(4)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`

export const StyledTextTitle = styled.div`
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`

export const StyledTextBody = styled.div`
  margin-left: ${pxToRem(3)};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
`

export const StyledText = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.unique.black};
`
